<template>
  <div class="container">
    <addForm
      v-if="dialogRoleVisible"
      :visible.sync="dialogRoleVisible"
      v-model="roleForm"
      @submitForm="search"
    ></addForm>
    <div class="eig-layout">
      <el-form
        class="clearfix"
        :model="filter"
        label-width="90px"
      >
        <div
          class="float-right"
          style="margin-left: 20px;margin-right: 10px;"
        >
          <el-button
            type="primary"
            @click="issue"
          >新增角色</el-button>
        </div>
      </el-form>
    </div>
    <el-table
      ref="filterTable"
      :data="page.blogs"
      style="width: 100%"
    >

      <el-table-column
        prop="name"
        label="角色名称"
      ></el-table-column>
      <el-table-column
        prop="authority"
        label="拥有权限"
        min-width="280"
      >
        <template slot-scope="scope">
          {{scope.row.authority | authorityFilter($store.state.menuList)}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="180"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="info"
            size="mini"
            @click="modify(scope.row)"
          >修改</el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteInfo(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page.page_index"
      :page-sizes="[8, 10, 30, 50]"
      :page-size="page.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.count"
    ></el-pagination>
    <el-dialog
      :close-on-click-modal="false"
      title="删除"
      :visible.sync="dialogFormVisible"
      :lock-scroll="false"
      width="35%"
    >
      <span>是否删除 "{{deleteObj.name}}" </span>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          @click="dialogFormVisible = false"
          size="small"
        >取 消</el-button>
        <el-button
          type="primary"
          @click="haddledeleteInfo"
          size="small"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import addForm from "./addForm.vue";
export default {
  data() {
    return {
      // 分页
      page: {
        page_size: 8,
        page_index: 1,
        blogs: [],
        count: 0,
      },
      // 删除对象
      deleteObj: {
        title: "",
        id: "",
      },
      filter: {
        title: "",
      },
      // 控制弹窗
      dialogFormVisible: false,
      dialogRoleVisible: false,
      roleForm: {
        authority: [],
      },
    };
  },
  filters: {
    authorityFilter(data, menuList) {
      let authorityList = [];
      data.forEach((element) => {
        menuList.forEach((item) => {
          item.children.forEach((childrenItem) => {
            if (childrenItem.path == element) {
              authorityList.push(childrenItem.name) 
              return
            }
          });
        });
      });
      return authorityList.join(',');
    },
  },
  created() {
    this.getInfo();
  },
  components: {
    addForm,
  },
  mounted() {},
  methods: {
    issue() {
      this.roleForm = {
        authority: [],
      };
      this.dialogRoleVisible = true;
    },
    search() {
      this.page.page_index = 1;
      this.getInfo();
    },
    // 占位符方式
    haddledeleteInfo() {
      this.$http
        .delete(`/sys/deleteRole/?id=${this.deleteObj.id}`)
        .then((res) => {
          this.dialogFormVisible = false;
          this.page = {
            page_size: 8,
            page_index: 1,
            blogs: [],
            count: 0,
          };
          this.getInfo();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 弹出删除博客框
    deleteInfo(row) {
      console.log(row);
      this.deleteObj.id = row.id;
      this.deleteObj.name = row.name;
      this.dialogFormVisible = true;
    },
    // 获取列表
    getInfo() {
      const { page_index, page_size } = this.page;
      this.$http
        .post("/sys/getRole", {
          page_size,
          page_index,
          filter: this.filter,
        })
        .then((res) => {
          console.log(res);
          if (res.status !== 200) return;
          console.log(res.data);
          this.page.blogs = res.data.blogs;
          this.page.blogs.forEach((item) => {
            item.authority = JSON.parse(item.authority);
          });
          this.page.count = res.data.count;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //   格式化
    formatter(row, column, cellValue, index) {
      const dt = new Date(cellValue);

      const y = dt.getFullYear();
      const m = (dt.getMonth() + 1 + "").padStart(2, "0");
      const d = (dt.getDate() + "").padStart(2, "0");

      const hh = (dt.getHours() + "").padStart(2, "0");
      const mm = (dt.getMinutes() + "").padStart(2, "0");
      const ss = (dt.getSeconds() + "").padStart(2, "0");

      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    },
    // 当前页改变
    handleCurrentChange(currentPageNumber) {
      console.log(currentPageNumber);
      this.page.page_index = currentPageNumber;
      this.getInfo();
    },
    // 当前每页数据量改变
    handleSizeChange(pageDataCount) {
      console.log(pageDataCount);
      this.page.page_size = pageDataCount;
      this.getInfo();
    },
    modify(row) {
      this.roleForm = row;
      this.dialogRoleVisible = true;
    },
  },
  beforeDestroy() {
    window.getInfo = null;
  },
};
</script>
<style lang='less' scoped>
/deep/.cell {
  text-align: center;
}
</style>